import RootLayout from '../component/Layout';
import styles from './features.module.scss';
import styles_mobile from './features_mobile.module.scss';
import TopLogo from '../component/TopLogo';
import Img from '../component/Img';
import Video from '../component/Video';
import { useEffect, useState } from 'react';
import useScreenWidthBelowThreshold from '../hooks/useScreenWidthBelowThreshold';

const slidesData = [
  {
    imgSrc:
      'https://cdn.duetapp.net/v1/images/eyJpZCI6IkVTUVZGRklKRVNIQUtXUjJFMkVNQU1UNFZLTFVFRiIsInciOjkyNCwiaCI6MzU2LCJkIjowLCJtdCI6ImltYWdlL2pwZWciLCJkaCI6NTA4Nzc4OTMyNjU1MjEyMX0',
    videoSrc:
      'https://cdn.duetapp.net/v1/videos/eyJpZCI6IjdGSEhOQk4zRDYyVkpFS0ZVMjRMUDZRSFNCM1JPNiIsInciOjIyNDgsImgiOjEwMDAsImQiOjUsIm10IjoidmlkZW8vbXA0IiwiZGgiOjcyMTE3MzU5NiwiYWIiOjB9',
  },
  {
    imgSrc:
      'https://cdn.duetapp.net/v1/images/eyJpZCI6IkNDNEJVNkxGVlFCTEdNUEpEWlFYQ1ZSWkQzNUJPWiIsInciOjkyNCwiaCI6MzU2LCJkIjowLCJtdCI6ImltYWdlL2pwZWciLCJkaCI6MjM0NTE2NjgzNjQ0MDAxNDl9',
    videoSrc:
      'https://cdn.duetapp.net/v1/videos/eyJpZCI6IllFTENNMkRLUkJVRzU3QkRSWUJVSjRXRTVURUtXSCIsInciOjIyNDgsImgiOjEwMDAsImQiOjcsIm10IjoidmlkZW8vbXA0IiwiZGgiOjE5MzQ1NjczOTcsImFiIjowfQ',
  },
  {
    imgSrc:
      'https://cdn.duetapp.net/v1/images/eyJpZCI6IlFQS1VSTUNKMkFBVElCREtQNTJSTDVBQlhWQ1dWMiIsInciOjkyNCwiaCI6MzU2LCJkIjowLCJtdCI6ImltYWdlL2pwZWciLCJkaCI6MjE0NjM4NjM2MDYxNDM1MjV9',
    videoSrc:
      'https://cdn.duetapp.net/v1/videos/eyJpZCI6IkdPSkFXM1U3T1JRU0RXWU83QjNLSklaM1hYM0xQVCIsInciOjIyNDgsImgiOjEwMDAsImQiOjUsIm10IjoidmlkZW8vbXA0IiwiZGgiOjE1NTQwNDQ1MywiYWIiOjB9',
  },
];

const slidesDataMobile = [
  {
    imgSrc:
      'https://cdn.duetapp.net/v1/images/eyJpZCI6IkJMSENETEFPTERVVExDSFpDVVdIWUVRSkFKQ1dZUCIsInciOjU1MiwiaCI6MjQ0LCJkIjowLCJtdCI6ImltYWdlL2pwZWciLCJkaCI6NDU2NDAwMDQxMTI5NTc5Mzc5LCJhYiI6MH0',
    videoSrc:
      'https://cdn.duetapp.net/v1/videos/eyJpZCI6IlpQNkRQQ0JUQVlBN09ESkpPVUpTVFZSSFFWWVNSViIsInciOjY1MCwiaCI6OTY0LCJkIjo1LCJtdCI6InZpZGVvL21wNCIsImRoIjozNTM4MjMxNjQ2LCJhYiI6MH0',
  },
  {
    imgSrc:
      'https://cdn.duetapp.net/v1/images/eyJpZCI6IjZRWUpZVkxQM1FGNDdEQkFTMkxRVFBHVEhYUFA2VyIsInciOjU1MCwiaCI6MjQ0LCJkIjowLCJtdCI6ImltYWdlL2pwZWciLCJkaCI6MTYxNDkyNDUxMDk3MTA0OTI1MX0',
    videoSrc:
      'https://cdn.duetapp.net/v1/videos/eyJpZCI6IlJKREpENzRPRDdZWkNIWVM3SFJIUktZVURCTFBFTyIsInciOjY1MCwiaCI6OTY0LCJkIjo2LCJtdCI6InZpZGVvL21wNCIsImRoIjo2NTU4ODg4MjAsImFiIjowfQ',
  },
  {
    imgSrc:
      'https://cdn.duetapp.net/v1/images/eyJpZCI6IlYyN0RITUgyNTdQNVdQMjdaSjdUTFU2S1FMRE5BQyIsInciOjU1MCwiaCI6MjQ0LCJkIjowLCJtdCI6ImltYWdlL2pwZWciLCJkaCI6MTAzNjc2ODM1NDUxMTExNTA4M30',
    videoSrc:
      'https://cdn.duetapp.net/v1/videos/eyJpZCI6IkJVM1dCRE0yMkhJSFpNNEpITEtTVERTNkNENlhXRyIsInciOjY1MCwiaCI6OTY0LCJkIjo2LCJtdCI6InZpZGVvL21wNCIsImRoIjo0NTI0MjMyNDYsImFiIjowfQ',
  },
];

export default () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const isScreenWidthBelow700px = useScreenWidthBelowThreshold(700);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prevSlide) => (prevSlide + 1) % 3);
    }, 10000);
    return () => clearInterval(timer);
  }, []);

  if (isScreenWidthBelow700px) {
    return (
      <RootLayout className={styles_mobile.wrapper}>
        <TopLogo />
        <div className={styles_mobile.card_wrapper}>
          <div className={styles_mobile.cards}>
            {slidesDataMobile.map((slide, index) => (
              <div
                key={index}
                className={`${styles_mobile.card} ${currentSlide === index ? styles_mobile.active : ''}`}
              >
                <Img src={slide.imgSrc} />
                <Video src={slide.videoSrc} />
              </div>
            ))}
          </div>
        </div>
        <div className={styles_mobile.dots}>
          {slidesData.map((_, index) => (
            <button
              key={index}
              className={`${styles_mobile.dot} ${index === currentSlide ? styles_mobile.active : ''}`}
              onClick={() => setCurrentSlide(index)}
            />
          ))}
        </div>
      </RootLayout>
    );
  } else {
    return (
      <RootLayout className={styles.wrapper}>
        <TopLogo />
        <div className={styles.card_wrapper}>
          <div className={styles.cards}>
            {slidesData.map((slide, index) => (
              <div key={index} className={`${styles.card} ${currentSlide === index ? styles.active : ''}`}>
                <Img src={slide.imgSrc} />
                <Video src={slide.videoSrc} />
              </div>
            ))}
          </div>
        </div>
        <div className={styles.dots}>
          {slidesData.map((_, index) => (
            <button
              key={index}
              className={`${styles.dot} ${index === currentSlide ? styles.active : ''}`}
              onClick={() => setCurrentSlide(index)}
            />
          ))}
        </div>
      </RootLayout>
    );
  }
};
